import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(protected authService: AuthService, private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        console.log('can activate')
        console.log('isAuth: ', this.authService.IsAuth())
        if (this.authService.IsAuth()) {
            return true;
        } else {
            this.router.navigate([''])
        }
    }
}
